import { AccessModes, Dimensions, Metrics, SortOrder, Sources, WITH_ID_SUFFIX } from 'components/insights/constants';

import { NetworkPerformanceQueryParams } from './query/useNetworkPerformanceAnalytics';

export const PROVIDER_PERFORMANCE_BASE_PARAMS: NetworkPerformanceQueryParams = {
  source: Sources.LOCATION_EPISODE_DISCHARGES,
  accessModes: [AccessModes.MANAGER],
  metrics: [
    Metrics.ID_COUNT,
    Metrics.LENGTH_OF_STAY_AVERAGE,
    Metrics.READMISSION_RATE,
    Metrics.OLIO_ENGAGEMENT_SCORE,
    Metrics.ACTIVITIES_PER_PATIENT_PER_WEEK,
  ],
  sortBy: `${Metrics.ID_COUNT} ${SortOrder.DESC}`,
};

export const PROVIDER_PERFORMANCE_TABLE_PARAMS: NetworkPerformanceQueryParams = {
  ...PROVIDER_PERFORMANCE_BASE_PARAMS,
  dimensions: [`${Dimensions.PROVIDER_CLIENT}${WITH_ID_SUFFIX}`],
  rollups: true,
};

export const PROVIDER_PERFORMANCE_EXPORT_PARAMS: NetworkPerformanceQueryParams = {
  ...PROVIDER_PERFORMANCE_BASE_PARAMS,
  dimensions: [Dimensions.PROVIDER_CLIENT],
};
